import { Link, useNavigate } from "react-router-dom";
import AuthService from "../services/auth.service";
import { useEffect, useState } from "react";
import Moment from 'moment';
import Loader from "../components/loader";

function MatchList() {
    const [isPageloading, setIsPageLoading] = useState(true);
    const [message, setMessage] = useState("");
    const [gameList, setGameList] = useState<any>([]);
    const navigate = useNavigate();

    useEffect(() => {
        getGamesList();

        // eslint-disable-next-line
    }, []);

    function getGamesList() {
        setIsPageLoading(true);
        AuthService.getGames('sports', 'fetch_games', 4)
            .then(
                (response) => {
                    //console.log(response.data);
                    if (response.status === 200) {
                        setGameList(response?.data);
                    } else {
                        setMessage(response?.message);
                    }
                }
            ).catch((error) => {
                //console.log(error?.status, error?.response?.data?.status)
                const message = error?.response?.data?.error_description;
                setMessage(message);
                if (error?.response?.data?.status === 401) {
                    localStorage.removeItem("w_token");
                    navigate('/login');
                }
            }).finally(() => {
                setIsPageLoading(false);
            });
    }

    function checkDateDiff(MatchDate: any) {
        let currentDate = Moment().utc().format();
        let datetime1 = Moment(currentDate);
        let datetime2 = Moment(MatchDate);
        let diffInMillis = datetime1.diff(datetime2);
        return diffInMillis;
    }

    return (
        <>
            {isPageloading && <Loader />}
            <section className="history series-List">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h1>Cricket Matches ({gameList.length})</h1>
                        </div>
                    </div>
                </div>
            </section>
            <section className="cricket" style={{ background: 'none', marginTop: 0, paddingTop: 0 }}>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                        {gameList.length === 0 && !isPageloading && <p className="text-danger text-center mt-5">No match found</p>}
                            {gameList.length > 0 && gameList.map((key: any, index: number) => (
                                <div className="cricketBetCard mt-0 mb-2" style={{ padding: '8px 10px' }} key={index}>
                                    <div className="cricketBetCardHead">
                                        <div className="tital">
                                            <p>
                                                {Moment(key?.openDate).format('MMM DD, yyyy, h:mm A')}
                                            </p>
                                            <Link to={`/game-detail/${key?.match_id}`} style={{ textDecoration: 'none' }}  >
                                                <h6>{key?.name}</h6>
                                            </Link>
                                        </div>
                                        <div className="videLiveBtn">
                                            <button className="fb">F</button>
                                            <button className="bm mx-2">BM</button>
                                            <button className="vedio">
                                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g clipPath="url(#clip0_89_509)">
                                                        <path d="M14.2498 17.0624H3.74976C3.00408 17.0616 2.28917 16.765 1.7619 16.2378C1.23462 15.7105 0.93805 14.9956 0.937256 14.2499V6.74991C0.93805 6.00423 1.23462 5.28932 1.7619 4.76205C2.28917 4.23477 3.00408 3.9382 3.74976 3.93741H14.2498C14.9954 3.9384 15.7102 4.23504 16.2374 4.76227C16.7646 5.2895 17.0613 6.00429 17.0623 6.74991V14.2499C17.0613 14.9955 16.7646 15.7103 16.2374 16.2375C15.7102 16.7648 14.9954 17.0614 14.2498 17.0624ZM3.74976 5.06241C3.30232 5.06281 2.87333 5.24072 2.55695 5.5571C2.24057 5.87349 2.06265 6.30248 2.06226 6.74991V14.2499C2.06265 14.6973 2.24057 15.1263 2.55695 15.4427C2.87333 15.7591 3.30232 15.937 3.74976 15.9374H14.2498C14.6971 15.9368 15.126 15.7588 15.4423 15.4425C15.7587 15.1262 15.9367 14.6973 15.9373 14.2499V6.74991C15.9367 6.30254 15.7587 5.87366 15.4423 5.55732C15.126 5.24098 14.6971 5.063 14.2498 5.06241H3.74976Z" fill="white" />
                                                        <path d="M8.19888 13.2164C7.84256 13.216 7.50093 13.0743 7.24897 12.8223C6.99701 12.5704 6.85528 12.2287 6.85489 11.8724V9.12742C6.85506 8.89847 6.91376 8.67336 7.0254 8.47347C7.13704 8.27358 7.29792 8.10555 7.49276 7.98532C7.68761 7.8651 7.90995 7.79667 8.13867 7.78653C8.3674 7.7764 8.59492 7.82489 8.79963 7.92742L11.1516 9.10342C11.3621 9.20864 11.5413 9.36729 11.6712 9.56349C11.8011 9.75969 11.8773 9.98656 11.892 10.2214C11.9067 10.4563 11.8595 10.6909 11.7551 10.9018C11.6507 11.1127 11.4928 11.2925 11.2971 11.4232L8.94363 12.9899C8.72336 13.1376 8.46411 13.2165 8.19888 13.2164ZM8.19888 8.90767C8.15829 8.90836 8.11864 8.92002 8.08414 8.94142C8.05214 8.96068 8.02574 8.98798 8.00759 9.02062C7.98943 9.05325 7.98013 9.09007 7.98063 9.12742V11.8724C7.98085 11.9119 7.99173 11.9506 8.01211 11.9843C8.0325 12.0181 8.06163 12.0458 8.09644 12.0644C8.13125 12.083 8.17043 12.0918 8.20985 12.09C8.24927 12.0881 8.28746 12.0757 8.32038 12.0539L10.6731 10.4857C10.7055 10.4651 10.7317 10.4361 10.7487 10.4017C10.7658 10.3673 10.7731 10.3289 10.7699 10.2907C10.7682 10.2521 10.7561 10.2147 10.7349 10.1824C10.7136 10.1502 10.684 10.1244 10.6491 10.1077L8.29639 8.93242C8.26609 8.91641 8.23239 8.90792 8.19813 8.90767H8.19888ZM8.99988 5.06242C8.926 5.0626 8.85282 5.04811 8.78459 5.01978C8.71635 4.99146 8.65442 4.94986 8.60239 4.89742L5.60238 1.89742C5.50302 1.79078 5.44893 1.64975 5.4515 1.50402C5.45407 1.3583 5.51311 1.21926 5.61617 1.1162C5.71923 1.01314 5.85827 0.954105 6.00399 0.951534C6.14972 0.948963 6.29075 1.00306 6.39738 1.10242L8.99988 3.70417L11.6024 1.10242C11.709 1.00306 11.8501 0.948963 11.9958 0.951534C12.1415 0.954105 12.2805 1.01314 12.3836 1.1162C12.4867 1.21926 12.5457 1.3583 12.5483 1.50402C12.5508 1.64975 12.4967 1.79078 12.3974 1.89742L9.39738 4.89742C9.34535 4.94986 9.28342 4.99146 9.21518 5.01978C9.14695 5.04811 9.07377 5.0626 8.99988 5.06242Z" fill="white" />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_89_509">
                                                            <rect width="18" height="18" fill="white" />
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </button>
                                            {checkDateDiff(key?.openDate) >= 0 &&
                                                <button className="live">
                                                    <svg className="dot" width="10" height="10" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx="4.08569" cy="4" r="4" fill="#162D13" />
                                                        <circle cx="4.08569" cy="4" r="4" fill="url(#paint0_linear_89_475)" />
                                                        <defs>
                                                            <linearGradient id="paint0_linear_89_475" x1="0.0856934" y1="4" x2="8.08569" y2="4" gradientUnits="userSpaceOnUse">
                                                                <stop stopColor="#A1F033" />
                                                                <stop offset="1" stopColor="#54880C" />
                                                            </linearGradient>
                                                        </defs>
                                                    </svg>
                                                    Live
                                                </button>
                                            }
                                        </div>
                                    </div>
                                    <div className="cricketBetCardBody">
                                        <ul>
                                            {/* {(key.odds).length > 0 && (key.odds).map((key: any, index: number) => (                                                    
                                                <React.Fragment key={index+'o'}> */}
                                            <li>
                                                <h3>{key.odds?.[0]?.['b1'] ? key.odds?.[0]?.['b1'] : '--'}</h3>
                                            </li>
                                            <li>
                                                <h3>{key.odds?.[0]?.['l1'] ? key.odds?.[0]?.['l1'] : '--'}</h3>
                                            </li>
                                            <li>
                                                <h3>{key.odds?.[2]?.['b1'] ? key.odds?.[2]?.['b1'] : '--'}</h3>
                                            </li>
                                            <li>
                                                <h3>{key.odds?.[2]?.['l1'] ? key.odds?.[2]?.['l1'] : '--'}</h3>
                                            </li>
                                            <li>
                                                <h3>{key.odds?.[1]?.['b1'] ? key.odds?.[1]?.['b1'] : '--'}</h3>
                                            </li>
                                            <li>
                                                <h3>{key.odds?.[1]?.['l1'] ? key.odds?.[1]?.['l1'] : '--'}</h3>
                                            </li>
                                            {/* </React.Fragment>
                                            ))} */}
                                        </ul>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default MatchList;